module.exports = __webpack_public_path__ + "static/media/CS1 -- 4.f7b2716a.jpg";